package com.essntl.features.price.data.supabase.supplierserviceprice

import com.essntl.features.currency.data.supabase.CurrencyDto
import com.essntl.features.price.domain.model.supplierserviceprice.SupplierServicePriceModel
import com.essntl.features.service.data.supabase.supplierservice.SupplierServiceDto
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SupplierServicePriceDto(
    val id: String,
    val description: String,
    val price: Int,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String,
    @SerialName("min_pax")
    val minPax: Int?,
    @SerialName("max_pax")
    val maxPax: Int?,
    @SerialName("tax_rate")
    val taxRate: Double?,
    val currency: CurrencyDto?,
    @SerialName("start_date")
    val startDate: String?,
    @SerialName("end_date")
    val endDate: String?,
    @SerialName("min_age")
    val minAge: Int?,
    @SerialName("max_age")
    val maxAge: Int?,
    val hours: List<String>?,
    val duration: Double?,
    @SerialName("days_valid")
    val daysValid: List<Int>?,
    val terms: String?,
    @SerialName("supplier_service_id_data")
    val supplierService: SupplierServiceDto?,
    @SerialName("default_selling_price")
    val defaultSellingPrice: Int?,
    val calculation: String?,
    @SerialName("updated_by")
    val updatedBy: String?,
) {

    fun toModel() = SupplierServicePriceModel(
        id = id,
        description = description,
        minPax = minPax,
        maxPax = maxPax,
        price = price,
        taxRate = taxRate,
        currency = currency?.toModel(),
        startDate = startDate,
        endDate = endDate,
        minAge = minAge,
        maxAge = maxAge,
        hours = hours,
        duration = duration,
        daysValid = daysValid,
        createdAt = createdAt,
        updatedAt = updatedAt,
        terms = terms,
        supplierService = supplierService?.toModel(),
        defaultSellingPrice = defaultSellingPrice,
        calculation = calculation,
        updatedBy = updatedBy,
    )

    companion object {
        const val COLUMNS_VALUE =
            "id, description, price, created_at, updated_at, min_pax, max_pax, tax_rate, start_date, end_date, min_age, max_age, hours, duration, days_valid, terms, supplier_service_id_data:supplier_service_id(${SupplierServiceDto.COLUMNS_VALUE}), default_selling_price, calculation, updated_by, currency(*)"

        fun getColumns() =
            Columns.raw(COLUMNS_VALUE)
    }
}